module.exports = __webpack_public_path__ + "static/media/mathworks.69a90787.png";